import { cn } from "@bidbattles/bloks/lib/ui";
import { LucideLoader2 } from "lucide-react";

function PageLoader({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			{...props}
			className={cn(
				"w-full h-full grow flex flex-col gap-4 items-center justify-center",
				className,
			)}
		>
			<LucideLoader2 className="animate-spin" />
			{props.children}
		</div>
	);
}

export { PageLoader };
